<div class="flex items-center gap-2 text-sm text-slate-700">
    <span [appTooltip]="hasOverflow ? guideText : null" class="min-w-0">
        {{ previewText }}
    </span>

    @if (hasOverflow) {
        <button
            type="button"
            class="badge badge-info cursor-pointer transition-all duration-200 hover:bg-blue-100 hover:text-blue-700"
            (click)="processOpenGuide()"
        >
            ...
        </button>
    }
</div>
